/**
 * @voltxampere/ui — INA126 precision instrumentation amp variant (Sprint 39-5)
 *
 * Burr-Brown INA126 single-channel precision differential amplifier
 * for strain gauge / Wheatstone bridge / medical sensor applications.
 * Macro stamp models the diff-amp gain product as a very high A0 =
 * 5 V/μV (= 5e6); user gain G is set externally via R_g (a
 * circuit-level concern, not a stamp parameter). 200 kHz GBW at
 * G=100, 0.4 V/μs slew, 100 μV typ input offset.
 *
 * Reference: TI SBOS027. Engine zero-diff invariant honored —
 * canonical "opamp" engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampIna126 = {
    id: "ina126",
    nameTr: "INA126 (Hassas Diferansiyel, DIP-8)",
    nameEn: "INA126 (Precision Differential, DIP-8)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "INA126",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 5e6,
        saturationVoltage: 13,
        gainBandwidthProduct: 200e3,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-ina126.js.map